import React, { ReactNode } from 'react';

import styled from 'styled-components';

import ForwardArrow from '../Included/WITBFeatureSection/ForwardArrow';
import { Link } from '../Link';

const StyledCard = styled.div<{ $isLink: boolean }>`
  padding: 15px;
  gap: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  border: 1px solid var(--stile-grey-3);
  transition: all 0.3s ease;
  cursor: ${(props) => (props.$isLink ? 'pointer' : 'default')};
  text-decoration: none;
  color: inherit;
  position: relative;

  ${(props) =>
    props.$isLink &&
    `
    &:hover {
      color: var(--grey-8);
      border-color: var(--stile-green-1);
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    }

    &:hover .arrow-icon {
      opacity: 1;
    }
  `}

  div {
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: center;
  }

  h6 {
    margin: 0;
  }

  .gatsby-image-wrapper {
    max-width: 100px;
    aspect-ratio: 1;
  }

  .arrow-icon {
    position: absolute;
    top: 15px;
    right: 15px;
    opacity: 0;
    transition: opacity 0.3s ease;
    color: var(--stile-green-1);
  }

  @media (max-width: 1024px) {
    align-self: stretch;
    flex-direction: row;
    min-width: 100%;

    .gatsby-image-wrapper {
      min-width: 80px;
    }
  }

  @media (max-width: 768px) {
    align-self: auto;
  }
`;

type CardGridCardProps = {
  image: ReactNode;
  title: string;
  subtitle: string;
  link?: string;
};

export default function CardGridCard({ image, title, subtitle, link }: CardGridCardProps) {
  const cardContent = (
    <>
      {image}
      <div>
        <h6>{title}</h6>
        <span>{subtitle}</span>
      </div>
      {link && <ForwardArrow className="arrow-icon" />}
    </>
  );

  if (link) {
    return (
      <StyledCard as={Link} url={link} $isLink={true}>
        {cardContent}
      </StyledCard>
    );
  }

  return <StyledCard $isLink={false}>{cardContent}</StyledCard>;
}
